module.exports = __webpack_public_path__ + "static/media/tiny_img_4.fd3f73b8.png";